module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ps-430e10095619ba7fa9946cfe002d68fa.svg";